module.exports = __webpack_public_path__ + "img/9788958075011.0c39822f.jpg";